var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65625 8.75C10.0728 8.75 12.0312 6.7915 12.0312 4.375C12.0312 1.9585 10.0728 0 7.65625 0C5.23975 0 3.28125 1.9585 3.28125 4.375C3.28125 6.7915 5.23975 8.75 7.65625 8.75ZM10.7187 9.84375H10.1479C9.38916 10.1924 8.54492 10.3906 7.65625 10.3906C6.76758 10.3906 5.92676 10.1924 5.16455 9.84375H4.59375C2.05762 9.84375 0 11.9014 0 14.4375V15.8594C0 16.7651 0.734863 17.5 1.64062 17.5H13.6719C14.5776 17.5 15.3125 16.7651 15.3125 15.8594V14.4375C15.3125 11.9014 13.2549 9.84375 10.7187 9.84375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.b3b4e7128fea7838c439fa8ef0a9a8ef.svg";
export { ForwardRef as ReactComponent };